module.exports = __webpack_public_path__ + "static/media/announcementsuccess.4ce6f626.svg";